<template>
  <div class="sharing-metadata-block">
    <el-form ref="metadata" :model="localMetadata" :rules="rules">
      <h3 class="meta-block-title">
        <!-- Metadata title -->
        <slot name="header">
          Metadata
        </slot>
      </h3>
      <!-- Prop fields -->
      <slot name="content" :metadata="localMetadata"></slot>
    </el-form>
  </div>
</template>

<script>
function parseMetadataObject(metadataProps) {
  return Object.fromEntries(metadataProps.map(({ id, value }) => [id, value]));
}

// @group Socials
// Sharing metadata template
export default {
  name: "SharingMetadata",
  props: {
    /** metadata props */
    metadataProps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localMetadata: parseMetadataObject(this.metadataProps)
    };
  },
  computed: {
    // @vuese
    // Prop values from parent component
    externalMetadata() {
      return parseMetadataObject(this.metadataProps);
    },
    // @vuese
    // Metadata rules
    rules() {
      return Object.fromEntries(
        this.metadataProps.map(({ id, rules }) => [id, rules ?? []])
      );
    },
    // @vuese
    // Metadata to update parent component parameters
    exportingMetadata() {
      return { ...this.localMetadata };
    }
  },
  watch: {
    // @vuese
    // Update internal metadata
    externalMetadata() {
      this.localMetadata = { ...this.externalMetadata };
    },
    // @vuese
    // Update metadata when it changed internally
    async exportingMetadata() {
      this.validateMetadata();
    }
  },
  methods: {
    // @vuese
    // Check metadata is valid and call of update (or call of invalid state) to parent component
    async validateMetadata() {
      const valid = await this.checkMetadataValid();

      if (valid) {
        this.$emit("update", this.exportingMetadata);
      } else {
        this.$emit("invalid");
      }
    },
    // @vuese
    // Check metadata is valid and return true or false
    async checkMetadataValid() {
      return new Promise(resolve => {
        this.$refs.metadata.validate(valid => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    }
  }
};
</script>
